import { getGameData, getPmpData, getShowIds } from "@/common/api";
import { IGameCell, IGameData, ShowIds } from "@/common/interface";
import { asyncInitAllAppStatus } from "@/store/common/action/appStatus";
import { Dispatch } from "redux";
import { SET_GAME_DATA } from "../actionTypes";
import {
  replaceComdataToGamepage,
  pmpBannerMap,
  pmpScheduleMap,
  pmpNetWorkMap,
  pmpAdMap,
  sortDataTop,
} from "@/utils/com";
// import {responsePmpdata} from '@/store/com/test'

export { setAppStatus, setAppProgress } from "@/store/common/action/appStatus";

export const setGameData = (data: IGameData) => ({
  type: SET_GAME_DATA,
  data,
});

export const asyncGetGameData = () => {
  return async (dispatch: Dispatch<any>) => {
    let showIds: ShowIds;
    try {
      showIds = await getShowIds();
    } catch (e) {
      showIds = {};
    }

    const {
      gameBannerIds = [],
      gameTabLine = [],
      gameTabNetWork = [],
      gameAdId = [],
    } = showIds;

    Promise.allSettled([
      getGameData(),
      getPmpData([
        ...gameBannerIds,
        ...gameTabLine,
        ...gameTabNetWork,
        ...gameAdId,
      ]),
    ]).then((res: any) => {
      const [gamePromise, pmpPromise] = res;

      if (
        gamePromise.status == "fulfilled" &&
        pmpPromise.status == "fulfilled"
      ) {
        // 合并数据
        replaceComdataToGamepage(
          gameBannerIds,
          pmpPromise.value,
          gamePromise.value.banner,
          pmpBannerMap,
        );
        replaceComdataToGamepage(
          gameTabLine,
          pmpPromise.value,
          gamePromise.value.dataTop,
          pmpScheduleMap,
        );
        replaceComdataToGamepage(
          gameTabNetWork,
          pmpPromise.value,
          gamePromise.value.network,
          pmpNetWorkMap,
        );
        replaceComdataToGamepage(
          gameAdId,
          pmpPromise.value,
          gamePromise.value.advertising,
          pmpAdMap,
        );
        sortDataTop(gamePromise.value.dataTop);
      }

      // replaceComdataToGamepage(gameTabNetWork, responsePmpdata, gamePromise.value.network, pmpNetWorkMap);
      dispatch(setGameData(gamePromise.value as IGameData));

      const keys = Object.keys(gamePromise.value);

      const arrList = keys.map((key) =>
        gamePromise.value[key].reduce(
          (result: number[], item: IGameCell) => [...result, item.soft_id],
          [],
        ),
      );

      const softIdList = arrList
        .reduce((arr, nextArr) => [...arr, ...nextArr], [])
        .filter((softId: number) => softId);
      dispatch(asyncInitAllAppStatus(softIdList));
    });
  };
};
